export const NEW_FILTER_CONCILIACAO_BANCARIA = 'NEW_FILTER_CONCILIACAO_BANCARIA'
export const NEW_FILTER_CONCILIACAO_BANCARIA_PENDING = 'NEW_FILTER_CONCILIACAO_BANCARIA_PENDING'
export const NEW_FILTER_CONCILIACAO_BANCARIA_SUCCESS = 'NEW_FILTER_CONCILIACAO_BANCARIA_SUCCESS'
export const NEW_FILTER_CONCILIACAO_BANCARIA_FAILURE = 'NEW_FILTER_CONCILIACAO_BANCARIA_FAILURE'

export const NEW_FILTER_NEXT_PAGE_CONCILIACAO_BANCARIA = 'NEW_FILTER_NEXT_PAGE_CONCILIACAO_BANCARIA'
export const NEW_FILTER_NEXT_PAGE_CONCILIACAO_BANCARIA_PENDING = 'NEW_FILTER_NEXT_PAGE_CONCILIACAO_BANCARIA_PENDING'
export const NEW_FILTER_NEXT_PAGE_CONCILIACAO_BANCARIA_SUCCESS = 'NEW_FILTER_NEXT_PAGE_CONCILIACAO_BANCARIA_SUCCESS'
export const NEW_FILTER_NEXT_PAGE_CONCILIACAO_BANCARIA_FAILURE = 'NEW_FILTER_NEXT_PAGE_CONCILIACAO_BANCARIA_FAILURE'

export const NEW_FILTER_EXTRATOS_OFX = 'NEW_FILTER_EXTRATOS_OFX'
export const NEW_FILTER_EXTRATOS_OFX_PENDING = 'NEW_FILTER_EXTRATOS_OFX_PENDING'
export const NEW_FILTER_EXTRATOS_OFX_SUCCESS = 'NEW_FILTER_EXTRATOS_OFX_SUCCESS'
export const NEW_FILTER_EXTRATOS_OFX_FAILURE = 'NEW_FILTER_EXTRATOS_OFX_FAILURE'

export const NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX = 'NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX'
export const NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX_PENDING = 'NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX_PENDING'
export const NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX_SUCCESS = 'NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX_SUCCESS'
export const NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX_FAILURE = 'NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX_FAILURE'

export const IGNORAR_TRANSACTION_CONCILIACAO = 'IGNORAR_TRANSACTION_CONCILIACAO'
export const IGNORAR_TRANSACTION_CONCILIACAO_PENDING = 'IGNORAR_TRANSACTION_CONCILIACAO_PENDING'
export const IGNORAR_TRANSACTION_CONCILIACAO_SUCCESS = 'IGNORAR_TRANSACTION_CONCILIACAO_SUCCESS'
export const IGNORAR_TRANSACTION_CONCILIACAO_FAILURE = 'IGNORAR_TRANSACTION_CONCILIACAO_FAILURE'

export const RESTAURAR_TRANSACTION_CONCILIACAO = 'RESTAURAR_TRANSACTION_CONCILIACAO'
export const RESTAURAR_TRANSACTION_CONCILIACAO_PENDING = 'RESTAURAR_TRANSACTION_CONCILIACAO_PENDING'
export const RESTAURAR_TRANSACTION_CONCILIACAO_SUCCESS = 'RESTAURAR_TRANSACTION_CONCILIACAO_SUCCESS'
export const RESTAURAR_TRANSACTION_CONCILIACAO_FAILURE = 'RESTAURAR_TRANSACTION_CONCILIACAO_FAILURE'

// Upload de arquivo OFX
export const UPLOAD_EXTRATOS_OFX = 'UPLOAD_EXTRATOS_OFX'
export const UPLOAD_EXTRATOS_OFX_PENDING = 'UPLOAD_EXTRATOS_OFX_PENDING'
export const UPLOAD_EXTRATOS_OFX_SUCCESS = 'UPLOAD_EXTRATOS_OFX_SUCCESS'
export const UPLOAD_EXTRATOS_OFX_FAILURE = 'UPLOAD_EXTRATOS_OFX_FAILURE'

// Conciliação de transações
export const CONCILIAR_TRANSACOES = 'CONCILIAR_TRANSACOES'
export const CONCILIAR_TRANSACOES_PENDING = 'CONCILIAR_TRANSACOES_PENDING'
export const CONCILIAR_TRANSACOES_SUCCESS = 'CONCILIAR_TRANSACOES_SUCCESS'
export const CONCILIAR_TRANSACOES_FAILURE = 'CONCILIAR_TRANSACOES_FAILURE'

export const DESCONCILIAR_TRANSACAO = 'DESCONCILIAR_TRANSACAO'
export const DESCONCILIAR_TRANSACAO_PENDING = 'DESCONCILIAR_TRANSACAO_PENDING'
export const DESCONCILIAR_TRANSACAO_SUCCESS = 'DESCONCILIAR_TRANSACAO_SUCCESS'
export const DESCONCILIAR_TRANSACAO_FAILURE = 'DESCONCILIAR_TRANSACAO_FAILURE'

// Controle de modais
export const SHOW_MODAL_OFX_CONFIRMACAO = 'SHOW_MODAL_OFX_CONFIRMACAO'
export const HIDE_MODAL_OFX_CONFIRMACAO = 'HIDE_MODAL_OFX_CONFIRMACAO'

export const SHOW_MODAL_CONCILIACAO_OPCOES = 'SHOW_MODAL_CONCILIACAO_OPCOES'
export const HIDE_MODAL_CONCILIACAO_OPCOES = 'HIDE_MODAL_CONCILIACAO_OPCOES'

// Modal buscar lançamentos - Lançamentos Banco
export const NEW_FILTER_LANCAMENTOS_BANCO_CONCILIACAO = 'NEW_FILTER_LANCAMENTOS_BANCO_CONCILIACAO'
export const NEW_FILTER_LANCAMENTOS_BANCO_CONCILIACAO_PENDING = 'NEW_FILTER_LANCAMENTOS_BANCO_CONCILIACAO_PENDING'
export const NEW_FILTER_LANCAMENTOS_BANCO_CONCILIACAO_SUCCESS = 'NEW_FILTER_LANCAMENTOS_BANCO_CONCILIACAO_SUCCESS'
export const NEW_FILTER_LANCAMENTOS_BANCO_CONCILIACAO_FAILURE = 'NEW_FILTER_LANCAMENTOS_BANCO_CONCILIACAO_FAILURE'

export const NEW_FILTER_NEXT_PAGE_LANCAMENTOS_BANCO_CONCILIACAO = 'NEW_FILTER_NEXT_PAGE_LANCAMENTOS_BANCO_CONCILIACAO'
export const NEW_FILTER_NEXT_PAGE_LANCAMENTOS_BANCO_CONCILIACAO_PENDING = 'NEW_FILTER_NEXT_PAGE_LANCAMENTOS_BANCO_CONCILIACAO_PENDING'
export const NEW_FILTER_NEXT_PAGE_LANCAMENTOS_BANCO_CONCILIACAO_SUCCESS = 'NEW_FILTER_NEXT_PAGE_LANCAMENTOS_BANCO_CONCILIACAO_SUCCESS'
export const NEW_FILTER_NEXT_PAGE_LANCAMENTOS_BANCO_CONCILIACAO_FAILURE = 'NEW_FILTER_NEXT_PAGE_LANCAMENTOS_BANCO_CONCILIACAO_FAILURE'

// Modal buscar lançamentos - Contas a Pagar
export const NEW_FILTER_CONTAS_PAGAR_CONCILIACAO = 'NEW_FILTER_CONTAS_PAGAR_CONCILIACAO'
export const NEW_FILTER_CONTAS_PAGAR_CONCILIACAO_PENDING = 'NEW_FILTER_CONTAS_PAGAR_CONCILIACAO_PENDING'
export const NEW_FILTER_CONTAS_PAGAR_CONCILIACAO_SUCCESS = 'NEW_FILTER_CONTAS_PAGAR_CONCILIACAO_SUCCESS'
export const NEW_FILTER_CONTAS_PAGAR_CONCILIACAO_FAILURE = 'NEW_FILTER_CONTAS_PAGAR_CONCILIACAO_FAILURE'

export const NEW_FILTER_NEXT_PAGE_CONTAS_PAGAR_CONCILIACAO = 'NEW_FILTER_NEXT_PAGE_CONTAS_PAGAR_CONCILIACAO'
export const NEW_FILTER_NEXT_PAGE_CONTAS_PAGAR_CONCILIACAO_PENDING = 'NEW_FILTER_NEXT_PAGE_CONTAS_PAGAR_CONCILIACAO_PENDING'
export const NEW_FILTER_NEXT_PAGE_CONTAS_PAGAR_CONCILIACAO_SUCCESS = 'NEW_FILTER_NEXT_PAGE_CONTAS_PAGAR_CONCILIACAO_SUCCESS'
export const NEW_FILTER_NEXT_PAGE_CONTAS_PAGAR_CONCILIACAO_FAILURE = 'NEW_FILTER_NEXT_PAGE_CONTAS_PAGAR_CONCILIACAO_FAILURE'

// Modal buscar lançamentos - Contas a Receber
export const NEW_FILTER_CONTAS_RECEBER_CONCILIACAO = 'NEW_FILTER_CONTAS_RECEBER_CONCILIACAO'
export const NEW_FILTER_CONTAS_RECEBER_CONCILIACAO_PENDING = 'NEW_FILTER_CONTAS_RECEBER_CONCILIACAO_PENDING'
export const NEW_FILTER_CONTAS_RECEBER_CONCILIACAO_SUCCESS = 'NEW_FILTER_CONTAS_RECEBER_CONCILIACAO_SUCCESS'
export const NEW_FILTER_CONTAS_RECEBER_CONCILIACAO_FAILURE = 'NEW_FILTER_CONTAS_RECEBER_CONCILIACAO_FAILURE'

export const NEW_FILTER_NEXT_PAGE_CONTAS_RECEBER_CONCILIACAO = 'NEW_FILTER_NEXT_PAGE_CONTAS_RECEBER_CONCILIACAO'
export const NEW_FILTER_NEXT_PAGE_CONTAS_RECEBER_CONCILIACAO_PENDING = 'NEW_FILTER_NEXT_PAGE_CONTAS_RECEBER_CONCILIACAO_PENDING'
export const NEW_FILTER_NEXT_PAGE_CONTAS_RECEBER_CONCILIACAO_SUCCESS = 'NEW_FILTER_NEXT_PAGE_CONTAS_RECEBER_CONCILIACAO_SUCCESS'
export const NEW_FILTER_NEXT_PAGE_CONTAS_RECEBER_CONCILIACAO_FAILURE = 'NEW_FILTER_NEXT_PAGE_CONTAS_RECEBER_CONCILIACAO_FAILURE'

// Modal buscar lançamentos - Contas Recorrentes
export const NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO = 'NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO'
export const NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO_PENDING = 'NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO_PENDING'
export const NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO_SUCCESS = 'NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO_SUCCESS'
export const NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO_FAILURE = 'NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO_FAILURE'

export const NEW_FILTER_NEXT_PAGE_CONTAS_RECORRENTES_CONCILIACAO = 'NEW_FILTER_NEXT_PAGE_CONTAS_RECORRENTES_CONCILIACAO'
export const NEW_FILTER_NEXT_PAGE_CONTAS_RECORRENTES_CONCILIACAO_PENDING = 'NEW_FILTER_NEXT_PAGE_CONTAS_RECORRENTES_CONCILIACAO_PENDING'
export const NEW_FILTER_NEXT_PAGE_CONTAS_RECORRENTES_CONCILIACAO_SUCCESS = 'NEW_FILTER_NEXT_PAGE_CONTAS_RECORRENTES_CONCILIACAO_SUCCESS'
export const NEW_FILTER_NEXT_PAGE_CONTAS_RECORRENTES_CONCILIACAO_FAILURE = 'NEW_FILTER_NEXT_PAGE_CONTAS_RECORRENTES_CONCILIACAO_FAILURE'

// Gerar conta agora (contas recorrentes)
export const GERAR_CONTA_AGORA_CONCILIACAO = 'GERAR_CONTA_AGORA_CONCILIACAO'
export const GERAR_CONTA_AGORA_CONCILIACAO_PENDING = 'GERAR_CONTA_AGORA_CONCILIACAO_PENDING'
export const GERAR_CONTA_AGORA_CONCILIACAO_SUCCESS = 'GERAR_CONTA_AGORA_CONCILIACAO_SUCCESS'
export const GERAR_CONTA_AGORA_CONCILIACAO_FAILURE = 'GERAR_CONTA_AGORA_CONCILIACAO_FAILURE'

// Resumo da conciliação
export const BUSCAR_RESUMO_CONCILIACAO = 'BUSCAR_RESUMO_CONCILIACAO'
export const BUSCAR_RESUMO_CONCILIACAO_PENDING = 'BUSCAR_RESUMO_CONCILIACAO_PENDING'
export const BUSCAR_RESUMO_CONCILIACAO_SUCCESS = 'BUSCAR_RESUMO_CONCILIACAO_SUCCESS'
export const BUSCAR_RESUMO_CONCILIACAO_FAILURE = 'BUSCAR_RESUMO_CONCILIACAO_FAILURE'

// Action types antigos (mantidos para compatibilidade com sagas existentes)
export const BUSCAR_LANCAMENTOS_BANCO = 'BUSCAR_LANCAMENTOS_BANCO'
export const BUSCAR_LANCAMENTOS_BANCO_PENDING = 'BUSCAR_LANCAMENTOS_BANCO_PENDING'
export const BUSCAR_LANCAMENTOS_BANCO_SUCCESS = 'BUSCAR_LANCAMENTOS_BANCO_SUCCESS'
export const BUSCAR_LANCAMENTOS_BANCO_FAILURE = 'BUSCAR_LANCAMENTOS_BANCO_FAILURE'
export const BUSCAR_LANCAMENTOS_BANCO_NEXT_PAGE = 'BUSCAR_LANCAMENTOS_BANCO_NEXT_PAGE'

export const BUSCAR_CONTAS_PAGAR = 'BUSCAR_CONTAS_PAGAR'
export const BUSCAR_CONTAS_PAGAR_PENDING = 'BUSCAR_CONTAS_PAGAR_PENDING'
export const BUSCAR_CONTAS_PAGAR_SUCCESS = 'BUSCAR_CONTAS_PAGAR_SUCCESS'
export const BUSCAR_CONTAS_PAGAR_FAILURE = 'BUSCAR_CONTAS_PAGAR_FAILURE'
export const BUSCAR_CONTAS_PAGAR_NEXT_PAGE = 'BUSCAR_CONTAS_PAGAR_NEXT_PAGE'

export const BUSCAR_CONTAS_RECEBER = 'BUSCAR_CONTAS_RECEBER'
export const BUSCAR_CONTAS_RECEBER_PENDING = 'BUSCAR_CONTAS_RECEBER_PENDING'
export const BUSCAR_CONTAS_RECEBER_SUCCESS = 'BUSCAR_CONTAS_RECEBER_SUCCESS'
export const BUSCAR_CONTAS_RECEBER_FAILURE = 'BUSCAR_CONTAS_RECEBER_FAILURE'
export const BUSCAR_CONTAS_RECEBER_NEXT_PAGE = 'BUSCAR_CONTAS_RECEBER_NEXT_PAGE'
